/* eslint-disable linebreak-style */
import React from 'react';

const shibIcon = (fill: string, size: number, style?: React.CSSProperties) => (
    <svg
        aria-hidden="true"
        data-testid="test-icon"
        id="Group_938"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size * 0.996}
        viewBox="0 0 24 24.28"
        style={style}
    >
        <title>shib icon</title>
        <g id="Group_931" transform="translate(0 0.797)">
            <path
                id="Path_8573"
                d="M1136.1,254.544a15.524,15.524,0,0,0-1.713,2.032l-.162-.053a11.721,11.721,0,0,0-2.869-.556c-.293-.023-1.386-.023-1.743,0a10.134,10.134,0,0,0-2.843.56c-.038.015-.071.026-.105.038a15.285,15.285,0,0,0-1.769-2.017,12.3,12.3,0,0,1,10.027-.53c.349.131.691.285,1.025.451Z"
                transform="translate(-1118.51 -253.196)"
                fill={fill || 'rgb(240, 5, 0)'}
                fillOpacity="0.7"
            />
            <path
                id="Path_8574"
                d="M976.829,394.915a11.664,11.664,0,0,1-2.094,3.669,13.013,13.013,0,0,1-1.638,1.6,12.092,12.092,0,0,1-4.724,2.328,12.394,12.394,0,0,1-5.8,0,12.068,12.068,0,0,1-4.724-2.328,13.012,13.012,0,0,1-1.638-1.6,11.521,11.521,0,0,1-2.095-11.239,12.19,12.19,0,0,1,.954-2.055c.176-.3.393-.635.5-.773.359,1.543.8,2.9.965,3.389a.84.84,0,0,1-.041.082,13.535,13.535,0,0,0-1.455,5.272c0,.022,0,.049,0,.071a3.25,3.25,0,0,0,.075,1.14,7.31,7.31,0,0,0,2.5,3.389,14.415,14.415,0,0,0,7.5,3.4c2.375.161,5.88-1.225,8.214-3.25a11.724,11.724,0,0,0,1.032-1.035,5.665,5.665,0,0,0,.55-.732c-.008,0,0-.007.015-.015s.022-.019.015-.026,0-.015.015-.019.019-.011.015-.019,0-.015.015-.019a.017.017,0,0,0,.011-.022c0-.007,0-.015.007-.015s.015-.011.015-.019.008-.019.015-.019a.016.016,0,0,0,.015-.015.392.392,0,0,1,.049-.086c.056-.086.281-.486.31-.553a5.148,5.148,0,0,0,.411-1.341,3.8,3.8,0,0,0,.034-.673c0-.015,0-.041-.007-.082-.007-.075-.011-.187-.019-.3-.008-.168-.023-.4-.034-.519a10.95,10.95,0,0,0-1.418-4.551,1.305,1.305,0,0,1-.082-.157.215.215,0,0,1-.015-.03h0c.116-.348.591-1.8.969-3.464l.007.007.056.075c.1.131.355.519.471.706a11.466,11.466,0,0,1,1.058,9.826Z"
                transform="translate(-953.47 -379.376)"
                fill={fill || 'rgb(240, 5, 0)'}
                fillOpacity="0.7"
            />
            <path
                id="Path_8575"
                d="M1343.393,516.332a1.264,1.264,0,0,1-.364.372,6.277,6.277,0,0,1-2.388.9,2.938,2.938,0,0,1-1.236.034c-.105-.053-.12-.094-.083-.229a1.827,1.827,0,0,1,.732-.879c.2-.147,1.025-.646,1.408-.856a4.978,4.978,0,0,1,1.487-.6.765.765,0,0,1,.282,0c.068.026.143.225.173.466A6.127,6.127,0,0,1,1343.393,516.332Z"
                transform="translate(-1324.884 -505.272)"
                fill="#806b6b"
            />
            <path
                id="Path_8576"
                d="M1105.859,518.575a.408.408,0,0,1-.263.113,4.242,4.242,0,0,1-.74-.019,7.774,7.774,0,0,1-2.257-.65,2.842,2.842,0,0,1-.777-.522l-.105-.109-.011-.143a3.936,3.936,0,0,1,.015-.777,1.02,1.02,0,0,1,.116-.331c.03-.038.03-.038.165-.038a1.626,1.626,0,0,1,.529.1,10.355,10.355,0,0,1,1.987.992,3.446,3.446,0,0,1,1.149.894A.75.75,0,0,1,1105.859,518.575Z"
                transform="translate(-1096.155 -506.272)"
                fill="#806b6b"
            />
            <path
                id="Path_8577"
                d="M1213.683,630.826c0,.011-.045.191-.1.406s-.1.387-.1.394a.644.644,0,0,1-.12,0h-.12l-.165.391c-.09.214-.173.413-.184.443l-.022.053-.079-.128-.079-.128v-1.04l-.03.008c-.064.015-.518.075-.717.094a10.228,10.228,0,0,1-2.468-.053c-.131-.019-.244-.034-.248-.03s0,.244.008.541l.011.533-.064.1c-.034.053-.068.1-.068.1s-.049-.049-.135-.222a2.548,2.548,0,0,1-.21-.571l-.026-.109-.116.008-.116.011-.03-.139c-.015-.075-.034-.191-.041-.255l-.011-.12-.1-.086c-.056-.049-.113-.1-.124-.105a.082.082,0,0,1-.026-.064v-.045l.469,0,.469,0,.015.049.015.049.161.008c.09,0,.376.011.631.019l.47.011.12-.188.124-.188h.158l0-.391,0-.391-.206-.09a2.016,2.016,0,0,1-1.2-1.033,1.444,1.444,0,0,1-.037-.488,1.487,1.487,0,0,1,.023-.488.545.545,0,0,1,.387-.383,8.927,8.927,0,0,1,1.119-.019l1.044,0,.117.056a.653.653,0,0,1,.281.222.62.62,0,0,1,.117.443,3.306,3.306,0,0,1-.056.721,1.555,1.555,0,0,1-.218.432,2,2,0,0,1-.841.59l-.09.034,0,.394,0,.394.083.008.083.008.113.169.109.169h.5c.278,0,.522,0,.545.008.038.008.045,0,.083-.06l.045-.068h.432A1.363,1.363,0,0,1,1213.683,630.826Z"
                transform="translate(-1198.684 -613.323)"
            />
            <path
                id="Path_8578"
                d="M1254.144,741.719c-.072.041-.12.06-.131.053s-.064-.049-.12-.09l-.1-.083-.105.113c-.229.248-.236.259-.3.263-.105.011-.128-.007-.255-.2-.068-.1-.12-.18-.12-.18s-.049-.008-.105-.011l-.1-.011-.049.1-.049.1-.086-.026a1.838,1.838,0,0,1-.2-.079l-.113-.056V741.4l1,0,1,0,0,.1C1254.3,741.629,1254.309,741.625,1254.144,741.719Z"
                transform="translate(-1241.126 -723.142)"
            />
        </g>
        <path
            id="Path_8579"
            d="M1015.534,581.8c0-.015,0-.041-.007-.083a7.923,7.923,0,0,0-5.835,1.814,4.537,4.537,0,0,0-4.355-3.53c-3.589,0-4.919,3.53-4.919,3.53a6.44,6.44,0,0,0-5.674-1.874c0,.023,0,.049,0,.071a3.285,3.285,0,0,0,.075,1.145,7.346,7.346,0,0,0,2.5,3.406,14.365,14.365,0,0,0,7.5,3.418c2.374.161,5.876-1.232,8.209-3.267a11.742,11.742,0,0,0,1.032-1.04,5.693,5.693,0,0,0,.55-.736c-.008,0,0-.007.015-.015s.023-.019.015-.026,0-.015.015-.019.019-.011.015-.019,0-.015.015-.019a.017.017,0,0,0,.011-.022c0-.008,0-.015.007-.015s.015-.011.015-.019.007-.019.015-.019a.016.016,0,0,0,.015-.015.39.39,0,0,1,.049-.086c.056-.086.28-.488.31-.556a5.2,5.2,0,0,0,.411-1.348A4.576,4.576,0,0,0,1015.534,581.8Zm-9.345,4.582c-.071.041-.12.06-.131.053s-.064-.049-.12-.09l-.1-.083-.1.113c-.228.248-.236.259-.3.263-.1.011-.127-.007-.254-.2-.067-.1-.12-.18-.12-.18s-.049-.007-.1-.011l-.1-.011-.049.1-.049.1-.086-.026a1.828,1.828,0,0,1-.2-.079l-.112-.056v-.214l.994,0,.994,0,0,.1C1006.35,586.291,1006.354,586.287,1006.189,586.381Zm1.869-.676c-.056.214-.1.387-.1.394a.632.632,0,0,1-.12,0h-.12l-.161.394c-.09.214-.172.413-.183.443l-.022.053-.078-.128-.079-.128V585.7l-.03.008c-.064.015-.516.075-.714.094a10.141,10.141,0,0,1-2.456-.053,2.474,2.474,0,0,0-.247-.03s0,.244.007.541l.011.533-.064.1c-.034.053-.067.1-.067.1s-.049-.049-.135-.222a2.547,2.547,0,0,1-.209-.571l-.026-.109-.116.008-.116.011-.03-.139c-.015-.075-.034-.192-.041-.255l-.011-.12-.1-.086c-.056-.049-.112-.1-.123-.105a.083.083,0,0,1-.026-.064v-.045l.467,0,.467,0,.015.049.015.049.161.008c.09,0,.374.011.628.019l.467.011.12-.188.123-.188h.157l0-.391,0-.391-.206-.09a2.009,2.009,0,0,1-1.2-1.033,1.442,1.442,0,0,1-.037-.488,1.5,1.5,0,0,1,.022-.488.545.545,0,0,1,.385-.383,8.877,8.877,0,0,1,1.114-.019l1.039,0,.116.056a.65.65,0,0,1,.28.222.623.623,0,0,1,.116.443,3.326,3.326,0,0,1-.056.721,1.562,1.562,0,0,1-.217.432,1.992,1.992,0,0,1-.837.59l-.09.034,0,.394,0,.394.082.008.082.007.112.169.108.169h.5c.277,0,.52,0,.542.008.037.008.045,0,.082-.06l.045-.068h.43a1.8,1.8,0,0,1,.43.015A2.592,2.592,0,0,0,1008.058,585.7Z"
            transform="translate(-993.176 -567.025)"
            fill="#fff"
        />
        <path
            id="Path_8580"
            d="M985.376,624.1a3.483,3.483,0,0,0-.376.071"
            transform="translate(-983.816 -609.431)"
            fill="none"
        />
        <path
            id="Path_8581"
            d="M1551.534,625.749a3.374,3.374,0,0,0-.334-.049"
            transform="translate(-1528.849 -610.971)"
            fill="none"
        />
        <path
            id="Path_8582"
            d="M1015.768,246.449c-.007-.169-.022-.406-.034-.522a11.052,11.052,0,0,0-1.417-4.574,1.313,1.313,0,0,1-.082-.158.225.225,0,0,1-.015-.03h0c.116-.349.591-1.81.968-3.481.512-2.268.837-4.92-.157-5.716,0,0-1.72-.128-4.022,2.141a15.5,15.5,0,0,0-1.7,2.032l-.161-.053a11.62,11.62,0,0,0-2.856-.556c-.292-.023-1.379-.023-1.734,0a10.046,10.046,0,0,0-2.83.56c-.037.015-.071.026-.1.038a15.267,15.267,0,0,0-1.761-2.017c-2.4-2.28-4.179-2.148-4.179-2.148-1.054.822-.7,3.594-.15,5.938.359,1.551.8,2.914.964,3.406a.865.865,0,0,1-.041.083,13.667,13.667,0,0,0-1.454,5.3,6.436,6.436,0,0,1,5.678,1.874s1.331-3.53,4.919-3.53a4.537,4.537,0,0,1,4.355,3.53,7.94,7.94,0,0,1,5.835-1.814C1015.783,246.675,1015.776,246.562,1015.768,246.449ZM997.2,239.892s-1.4-3.512-1.039-5.517h0a1.939,1.939,0,0,1,.348-.86s1.585.158,4.142,3.012a7.3,7.3,0,0,0-1.136.74.013.013,0,0,1-.007,0,9.015,9.015,0,0,0-2.306,2.621Zm5.932,5.217a.406.406,0,0,1-.262.113,4.209,4.209,0,0,1-.736-.019,7.71,7.71,0,0,1-2.246-.65,2.829,2.829,0,0,1-.774-.522l-.1-.109-.011-.143a3.943,3.943,0,0,1,.015-.777,1.021,1.021,0,0,1,.116-.331c.03-.038.03-.038.164-.038a1.612,1.612,0,0,1,.527.1,10.274,10.274,0,0,1,1.977.992,3.431,3.431,0,0,1,1.144.894A.753.753,0,0,1,1003.134,245.109Zm8.807-1.243a1.261,1.261,0,0,1-.363.372,6.231,6.231,0,0,1-2.377.9,2.909,2.909,0,0,1-1.23.034c-.1-.053-.12-.094-.082-.229a1.825,1.825,0,0,1,.729-.879c.2-.146,1.02-.646,1.4-.856a4.939,4.939,0,0,1,1.48-.6.756.756,0,0,1,.28,0c.067.026.142.225.172.466A6.138,6.138,0,0,1,1011.94,243.865Zm-.62-6.6-.007,0a6.973,6.973,0,0,0-1.1-.74c2.471-2.854,4-3.012,4-3.012a2.043,2.043,0,0,1,.336.86h0c.348,2.006-1,5.521-1,5.521a8.933,8.933,0,0,0-2.228-2.625Z"
            transform="translate(-993.44 -231.963)"
            fill={fill || '#ffa409'}
        />
        <path
            id="Path_8583"
            d="M1377.119,343.2c-.008.008-.011.019-.019.026"
            transform="translate(-1361.255 -339.022)"
            fill="none"
        />
        <path
            id="Path_8584"
            d="M1508.426,476.9c-.019.053-.026.079-.026.079"
            transform="translate(-1487.657 -467.737)"
            fill="none"
        />
        <g id="Group_934" transform="translate(16.747 1.549)">
            <g id="Group_933">
                <g id="Group_932">
                    <path
                        id="Path_8585"
                        d="M1406.36,274.06c-.293-.038-1.679-.045-3.249,2.9l-.008,0a7.008,7.008,0,0,0-1.1-.74c2.482-2.854,4.019-3.012,4.019-3.012A1.993,1.993,0,0,1,1406.36,274.06Z"
                        transform="translate(-1402 -273.2)"
                        fill={fill || '#ff9300'}
                        fillOpacity="0.3"
                    />
                </g>
                <path
                    id="Path_8586"
                    d="M1433.842,301.43a8.913,8.913,0,0,0-2.242-2.625c1.57-2.941,2.952-2.933,3.248-2.9h0C1435.2,297.918,1433.842,301.43,1433.842,301.43Z"
                    transform="translate(-1430.488 -295.049)"
                    fill={fill || '#ff8300'}
                    fillOpacity="0.2"
                />
                <path
                    id="Path_8587"
                    d="M1518.156,296.111l-.056-.011Z"
                    transform="translate(-1513.74 -295.24)"
                    fill={fill || '#ff8300'}
                    fillOpacity="0.2"
                />
            </g>
        </g>
        <path
            id="Path_8588"
            d="M1172.116,343.058c-.037-.053-.079-.105-.116-.158"
            transform="translate(-1163.826 -338.734)"
            fill="none"
        />
        <path
            id="Path_8589"
            d="M1035,480.8c.041.128.068.2.068.2"
            transform="translate(-1031.938 -471.492)"
            fill="none"
        />
        <g id="Group_937" transform="translate(2.668 1.549)">
            <g id="Group_936">
                <g id="Group_935" transform="translate(0.056)">
                    <path
                        id="Path_8590"
                        d="M1030.514,276.212a7.349,7.349,0,0,0-1.142.74.013.013,0,0,1-.007,0c-1.626-2.944-3.057-2.933-3.365-2.9a1.936,1.936,0,0,1,.349-.86S1027.945,273.358,1030.514,276.212Z"
                        transform="translate(-1026 -273.2)"
                        fill={fill || '#ff9300'}
                        fillOpacity="0.3"
                    />
                </g>
                <path
                    id="Path_8591"
                    d="M1027.948,298.8a9,9,0,0,0-2.321,2.625s-1.4-3.511-1.044-5.521h0C1024.887,295.871,1026.322,295.864,1027.948,298.8Z"
                    transform="translate(-1024.523 -295.049)"
                    fill={fill || '#ff8300'}
                    fillOpacity="0.2"
                />
                <path
                    id="Path_8592"
                    d="M1024.56,296.1l-.06.011Z"
                    transform="translate(-1024.5 -295.24)"
                    fill={fill || '#ff8300'}
                    fillOpacity="0.2"
                />
            </g>
        </g>
        <path
            id="Path_8593"
            d="M1362.818,446.722s-1.2.075-1.052-.864a1.241,1.241,0,0,1,1.352-1.014c.263.038,1.314.413,1.127,1.2s-.451.638-.6.676A5.952,5.952,0,0,1,1362.818,446.722Z"
            transform="translate(-1346.49 -436.877)"
            fill="#fff"
        />
        <path
            id="Path_8594"
            d="M1126.818,446.722s-1.2.075-1.052-.864a1.241,1.241,0,0,1,1.352-1.014c.263.038,1.314.413,1.127,1.2s-.451.638-.6.676A5.951,5.951,0,0,1,1126.818,446.722Z"
            transform="translate(-1119.313 -436.877)"
            fill="#fff"
        />
    </svg>
);
export default shibIcon;
